module.exports = __webpack_public_path__ + "static/media/bell.6043f8db.svg";